angular.module('picmonic-common').factory('EasyLinkResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/easy-link');
  },
]);
